import React from 'react';
import { BwjPageContent } from '../../../../framework/components/bwj-page-content';
import { AppRoutes, useProjectOverviewParams } from '../../../app-routes';
import { ProjectOverviewService } from '../../services/project-overview';
import { BwjViewManager, BwjViewState } from '../../../../framework/components/bwj-view-manager';
import { MaterialManagementListing } from '../../components/material-mgmt-listing';
import { IMaterialCallout } from '../../../../entities-generated/common/material-callout';

export const PageProjectOverviewMaterials: React.FunctionComponent = () => {
  const { id: projectId } = useProjectOverviewParams();
  const project = ProjectOverviewService.getOverview(projectId)!;
  const viewState = project.materials.length > 0 ? BwjViewState.Ready : BwjViewState.NoSearchResults;

  const onViewOnVendorSite = (material: IMaterialCallout) => {
    window.open(`${material.vendorUrl}`, '_blank');
  }

  return (
    <BwjViewManager
      state={viewState}
      noSearchResultsState={{
        icon: AppRoutes.projectOverviewMaterials.icon,
        message: 'No materials noted at present'
      }}
    >
      <BwjPageContent contentDescription={'primary content (no subcontent)'}>
        {project.materials.map(material =>
          <MaterialManagementListing
            key={material.id}
            material={material}
            onViewVendorSite={onViewOnVendorSite}
          />
        )}
      </BwjPageContent>
    </BwjViewManager>
  );
};
